// import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

// plugins styles from node_modules
import "react-perfect-scrollbar/dist/css/styles.css";
// import "@fullcalendar/common/main.min.css"; // Poistettu, koska aiheuttaa virheen
// import "@fullcalendar/daygrid/main.min.css"; // Poistettu, koska aiheuttaa virheen
// import "sweetalert2/dist/sweetalert2.min.css";
// import "select2/dist/css/select2.min.css"; // Poistettu, koska aiheuttaa virheen

// React-toastify styles
import 'react-toastify/dist/ReactToastify.css';

// Font Awesome 5 icons
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
// Nucleo icons
import "assets/vendor/nucleo/css/nucleo.css"; // icons

// React-datepicker
import "react-datepicker/dist/react-datepicker.css";

// Use new Bootstrap structure
import "./assets/scss/main.scss";

// Load translations before rendering the app (registers moment locales for fi/sv)
import i18n, { syncMomentLocale } from "./services/i18n";

import { AuthProvider } from "contexts/AuthContext";
import { NotificationProvider } from "contexts/NotificationContext"
import { WebSocketProvider } from "contexts/WebSocketContext";
import { StoreProvider } from 'easy-peasy';
import { store } from 'store/index';

import App from "./app";

// Global error handlers
window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled promise rejection:', event.reason);
  // Prevent the default browser behavior
  event.preventDefault();
});

window.addEventListener('error', function(event) {
  console.error('Global error:', event.error);
});

// Ensure user language is set for i18next and moment
const userLanguage = localStorage.getItem("language") || "fi";
i18n.changeLanguage(userLanguage);
syncMomentLocale(userLanguage);

ReactDOM.render(
  <BrowserRouter>
    <StoreProvider store={store}>
      <AuthProvider>
        <WebSocketProvider>
          <NotificationProvider>
            <App />
          </NotificationProvider>
        </WebSocketProvider>
      </AuthProvider>
    </StoreProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
